import {useState} from 'react';
import styles from "./Profile.module.css"

import {Link, useNavigate} from "react-router-dom"

import { useAuth } from '../../contexts/authContext';

import Sidebar from '../HomeSidebar/HomeSidebar';

export default function Profile() {
  const {logout, currentUser} = useAuth()
  
  const [error, setError] = useState()

  const navigate = useNavigate()

  async function handleLogOut() {
    setError("");

    try {
      await logout()

      navigate("/login")
    } catch(e) {
      setError("Logout failed")
      console.log(e)
    }
  }

  return (
    <section className={styles.profilePage}>
      <Sidebar selectedOption="profile" />

      <div className={styles.mainContent}>
        <h2>Profile</h2>

        {error && <p>error</p>}

        <div className={styles.profileInfo}>
          <p><span className={styles.title}>Email</span>: {currentUser.email}</p>

          <Link to="/update-profile" className={styles.updateProfile}>Update Profile</Link>

          <button onClick={handleLogOut}>Log Out</button>
        </div>
      </div>
    </section>
  );
}
